/* unplugin-vue-components disabled */import script from "./bilibiliGameDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./bilibiliGameDetail.vue?vue&type=script&setup=true&lang=ts"

import "./bilibiliGameDetail.vue?vue&type=style&index=0&id=852c9aa8&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-852c9aa8"]])

export default __exports__